import { render, staticRenderFns } from "./XrayComponent.vue?vue&type=template&id=7f8286a7&"
import script from "./XrayComponent.vue?vue&type=script&lang=js&"
export * from "./XrayComponent.vue?vue&type=script&lang=js&"
import style0 from "./XrayComponent.vue?vue&type=style&index=0&id=7f8286a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports